module.exports = __webpack_public_path__ + "static/media/icon-post.a8deb3d4.svg";